import { Loading, Container } from './styled';

export default function LoadingPage() {
  return (
    <Container>
      <Loading />
    </Container>
  );
}
